import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../../../../../components/WMS/Mobile/Popup";
import {ReactComponent as ScanBoxIcon} from "assets/img/wms/scanBox.svg"
import TextEmphasisBloc from "../../../../../../../../../components/WMS/TextEmphasisBloc";
import CustomButton from "../../../../../../../../../components/CustomButton";
import {Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {BarCodeScannerContext} from "../../../../../../../../../contexts/barCodeScannerContext";
import {WMSContext} from "../../../../../../../context/WMSContext";
import {ShippingMethodsDiscr} from "../../../../../../../../../utils/ShippingMethods";
import MondialRelayIcon from "../../../../../../../../../assets/img/carrier-icons/mondial_relay.svg";
import ClickAndCollectIcon from "../../../../../../../../../assets/img/carrier-icons/click_and_collect.svg";
import ShipmentModalSubtitle from "./ShipmentModalSubtitle";

ShipmentModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    shipment: PropTypes.object.isRequired,
    sortShipment: PropTypes.func.isRequired,
    manualSelection: PropTypes.func.isRequired
};

function ShipmentModal({open, handleClose, shipment, sortShipment, manualSelection}) {
    const {currentInventory} = useContext(WMSContext)
    const {scannedString, resetScannedString, setEnableScan} = useContext(BarCodeScannerContext)

    const getShippingMethodIcon = (discr) => {
        switch (discr) {
            case ShippingMethodsDiscr.MONDIAL_RELAY:
                return MondialRelayIcon
            case ShippingMethodsDiscr.CLICK_COLLECT:
                return ClickAndCollectIcon
        }
    }

    useEffect(() => {
        if (scannedString && scannedString.length > 0) {
            setEnableScan(false)
            sortShipment(scannedString)
        }
    }, [scannedString]);

    useEffect(() => {
        setEnableScan(true)
        resetScannedString()
    }, []);

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={(<FormattedMessage id='wms.triShipping.shipmentModal.title' />)}
            subtitle={(
                <ShipmentModalSubtitle orderNumber={shipment.orderNumber} trackingNumber={shipment.trackingNumber} />
            )}
            icon={<ScanBoxIcon/>}
            isMobile={true}
        >
            <Grid container gap={"32px"}>
                <TextEmphasisBloc
                    leftPart={
                        <span>
                            <img
                                src={getShippingMethodIcon(shipment.shippingMethodIcon)}
                                alt={shipment.shippingMethod}
                            /> {shipment.shippingMethod}
                        </span>
                    }
                />
                <CustomButton fullWidth onClick={() => manualSelection()}><FormattedMessage id={"wms.triShipping.modal.buttonLabel"}/></CustomButton>
            </Grid>
        </Popup>
    );
}

export default ShipmentModal;
